import { Account, AccountDetails } from '../../../types';
import React from 'react';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import useForceRefresh from 'components/shared/hooks/useForceRefresh';
import { useForm } from 'react-hook-form';
import { showSnackbar } from 'components/shared/index';
import EditPage from 'components/shared/CRUD/components/InnerPage/EditPage';
import { AccountFormFields } from './AccountFormFields';
import { ADMINISTRATION_ACCOUNTS } from 'RestAPIs/endpoints';
import { isEmpty } from 'ramda';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';
import { yupResolver } from '@hookform/resolvers/yup';
import { accountSchema, groupsSchema } from './utils/schema';

interface Props {
  data: AccountDetails;
  toggleInnerLayout: () => void;
  currentViewData: Account;
  setCurrentViewData: React.Dispatch<Account>;
  accounts: Account[];
}

export const EditAccountGroupsPage: React.FC<Props> = ({
  data: details,
  accounts,
  currentViewData,
  setCurrentViewData,
  toggleInnerLayout
}) => {
  const { t } = useTranslation('common');
  const methods = useForm({
    defaultValues: details,
    resolver: yupResolver(
      yup.object().concat(groupsSchema).concat(accountSchema)
    )
  });

  const { timestamp: isEditable, refresh: setIsEditable } = useForceRefresh();
  const { mutateAsync: update } = useUpdateResource({
    id: currentViewData.accountId,
    url: ADMINISTRATION_ACCOUNTS,
    invalidateQueryKey: ['accounts', 'list']
  });

  const onSubmit = async (formData) => {
    await update(
      {
        ...formData,
        empId: isEmpty(formData.empId) ? undefined : formData.empId
      },
      {
        onSuccess: () => {
          showSnackbar({ message: t('changesSaved') });
          setIsEditable();
        },
        onError: () => {
          showSnackbar({
            message: t('somethingWentWrong'),
            severity: 'error'
          });
        }
      }
    );
  };

  return (
    <EditPage
      currentView={currentViewData}
      isEditable={isEditable}
      methods={methods}
      navigatorLabelGetter={['accountId', 'accountName']}
      navigatorValueGetter={'accountName'}
      onCancel={() => methods.reset()}
      onSubmit={methods.handleSubmit(onSubmit)}
      setCurrentView={setCurrentViewData}
      toggleInnerLayout={toggleInnerLayout}
      views={accounts}
      withTabs={true}
    >
      <AccountFormFields originalDetails={details} />
    </EditPage>
  );
};
